import { render, staticRenderFns } from "./TabsExample.vue?vue&type=template&id=a9b551f6&"
import script from "./TabsExample.vue?vue&type=script&lang=js&"
export * from "./TabsExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports